import { CompletedTicketOptions } from '../models/CompletedTicketsByArea'
import { TicketRepository } from '../repositories/TicketRepository'

export function ListCompletedTicketsByAreaCase(
  ticketRepository: TicketRepository
) {
  return async function ({
    areaId,
    data
  }: {
    areaId: string
    data: CompletedTicketOptions
  }) {
    return await ticketRepository.listCompletedTicketsByArea({
      areaId,
      data
    })
  }
}
